import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "px-10"
}
const _hoisted_2 = { class: "fv-row mb-7" }
const _hoisted_3 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 4 }
const _hoisted_21 = { key: 5 }
const _hoisted_22 = { key: 6 }
const _hoisted_23 = { key: 7 }
const _hoisted_24 = { key: 8 }
const _hoisted_25 = { key: 9 }
const _hoisted_26 = { key: 10 }
const _hoisted_27 = { key: 11 }
const _hoisted_28 = { key: 12 }

import { useStore } from "@/store";
import { nextTick, provide, ref } from "vue";
import AccountRebate from "./AccountRebate.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import AccountReferCode from "./AccountReferCode.vue";
import AccountDetailLog from "./AccountDetailLog.vue";
import SiderDetail from "@/components/SiderDetail.vue";
import AccountService from "../services/AccountService";
import SiderDetail2 from "@/components/SiderDetail2.vue";
import AccountDetailCredit from "./AccountDetailCredit.vue";
import AccountDetailTrades from "./AccountDetailTrades.vue";
import { ConfigCategory } from "@/core/types/ConfigCategory";
import AccountDetailInfoForm from "./AccountDetailInfoForm.vue";
import LoadingCentralBox from "@/components/LoadingCentralBox.vue";
import PaymentMethodDetailForm from "./PaymentMethodDetailForm.vue";
import AccountDetailTransactions from "./AccountDetailTransactions.vue";
import UserApiLog from "@/projects/tenant/modules/users/components/UserApiLog.vue";
import ConfigList from "@/projects/tenant/modules/system/components/config/ConfigList.vue";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import AccountDetailStat from "@/projects/tenant/modules/accounts/components/AccountDetailStat.vue";
import AccountDetailDeposit from "@/projects/tenant/modules/accounts/components/AccountDetailDeposit.vue";
import AccountDetailWithdrawal from "@/projects/tenant/modules/accounts/components/AccountDetailWithdrawal.vue";

enum AccountDetailTab {
  AccountInfo = "infos",
  TradeRecord = "trade",
  TransactionRecord = "transaction",
  Rebate = "rebate",
  PaymentService = "payment",
  PaymentMethod = "paymentMethod",
  Withdrawal = "withdraw",
  Deposit = "deposit",
  Documents = "documents",
  Credit = "credit",
  Config = "config",
  Refer = "refer",
  Stat = "stat",
  Log = "log",
  ApiLog = "apiLog",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetail',
  setup(__props, { expose: __expose }) {

const store = useStore();
const isLoading = ref(true);
const infos = ref({} as any);
const submitted = ref(false);
const accountDetails = ref({} as any);
const detailTitle = ref(`Account Detail: loading...`);
const tenant = ref(store.state.AuthModule.user?.tenancy);
const tab = ref<AccountDetailTab>(AccountDetailTab.AccountInfo);
const accountDetailShowRef = ref<InstanceType<typeof SiderDetail>>();

provide(AccountInjectionKeys.ACCOUNT_DETAILS, accountDetails);

const show = async (
  id: number,
  selectedTab: string,
  paymentService: Array<any>,
  _accountDetails?: any
) => {
  isLoading.value = true;
  try {
    accountDetails.value = {} as any;
    infos.value = {} as any;
    if (_accountDetails) {
      accountDetails.value = _accountDetails;
    } else if (id !== -1) {
      accountDetails.value = await AccountService.getAccountDetailById(id);
    }

    detailTitle.value =
      accountDetails.value.name +
      " Account Detail: " +
      accountDetails.value.tradeAccount?.accountNumber;
    infos.value = accountDetails.value;

    tab.value = selectedTab as AccountDetailTab;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
    await nextTick();
  }
  accountDetailShowRef.value?.show();
};

const changeTab = (_tab: AccountDetailTab) => {
  tab.value = _tab;
};

const submit = async () => {
  console.log("tbd");
};

const close = () => {
  accountDetailShowRef.value?.hide();
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SiderDetail2, {
    save: submit,
    discard: close,
    title: detailTitle.value,
    elId: "user_detail_show",
    isLoading: isLoading.value,
    submited: submitted.value,
    isDisabled: false,
    savingTitle: _ctx.$t('action.saving'),
    "show-footer": false,
    width: "85%",
    ref_key: "accountDetailShowRef",
    ref: accountDetailShowRef
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createBlock(LoadingCentralBox, { key: 0 }))
        : _createCommentVNode("", true),
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("ul", _hoisted_3, [
                _createElementVNode("li", _hoisted_4, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.AccountInfo }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab(AccountDetailTab.AccountInfo)))
                  }, _toDisplayString(_ctx.$t("fields.info")), 3)
                ]),
                _createElementVNode("li", _hoisted_5, [
                  (accountDetails.value.accountNumber != 0)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.TradeRecord }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab(AccountDetailTab.TradeRecord)))
                      }, _toDisplayString(_ctx.$t("title.trade")), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_6, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.TransactionRecord }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(AccountDetailTab.TransactionRecord)))
                  }, _toDisplayString(_ctx.$t("title.transfer")), 3)
                ]),
                _createElementVNode("li", _hoisted_7, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.Deposit }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (changeTab(AccountDetailTab.Deposit)))
                  }, _toDisplayString(_ctx.$t("title.deposit")), 3)
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.Withdrawal }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (changeTab(AccountDetailTab.Withdrawal)))
                  }, _toDisplayString(_ctx.$t("title.withdrawal")), 3)
                ]),
                _createElementVNode("li", _hoisted_9, [
                  (tenant.value != 'jp' && tenant.value != 'au')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.Rebate }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (changeTab(AccountDetailTab.Rebate)))
                      }, _toDisplayString(_ctx.$t("title.rebate")), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.PaymentMethod }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (changeTab(AccountDetailTab.PaymentMethod)))
                  }, _toDisplayString(_ctx.$t("title.paymentMethod") + " (Account)"), 3)
                ]),
                _createElementVNode("li", _hoisted_11, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.Credit }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (changeTab(AccountDetailTab.Credit)))
                  }, _toDisplayString(_ctx.$t("title.creditAdjust")), 3)
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.Config }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (changeTab(AccountDetailTab.Config)))
                  }, _toDisplayString(_ctx.$t("title.config")), 3)
                ]),
                _createElementVNode("li", _hoisted_13, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.Refer }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (changeTab(AccountDetailTab.Refer)))
                  }, _toDisplayString(_ctx.$t("fields.referralCode")), 3)
                ]),
                _createElementVNode("li", _hoisted_14, [
                  (tenant.value != 'jp')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.Stat }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (changeTab(AccountDetailTab.Stat)))
                      }, _toDisplayString(_ctx.$t("fields.stat")), 3))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.Log }]),
                    "data-bs-toggle": "tab",
                    href: "#",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (changeTab(AccountDetailTab.Log)))
                  }, _toDisplayString(_ctx.$t("title.log")), 3)
                ]),
                _createElementVNode("li", _hoisted_16, [
                  (_ctx.$can('SuperAdmin'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: _normalizeClass(["nav-link text-active-primary pb-4", { active: tab.value === AccountDetailTab.ApiLog }]),
                        "data-bs-toggle": "tab",
                        href: "#",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (changeTab(AccountDetailTab.ApiLog)))
                      }, "ApiLog", 2))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (tab.value === AccountDetailTab.AccountInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(AccountDetailInfoForm, { infos: infos.value }, null, 8, ["infos"])
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.TradeRecord)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(AccountDetailTrades, {
                    accountId: accountDetails.value.id,
                    serviceId: accountDetails.value.serviceId
                  }, null, 8, ["accountId", "serviceId"])
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.TransactionRecord)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(AccountDetailTransactions, {
                    accountId: accountDetails.value.id,
                    partyId: accountDetails.value.partyId
                  }, null, 8, ["accountId", "partyId"])
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.Rebate)
              ? (_openBlock(), _createBlock(AccountRebate, {
                  key: 3,
                  "account-details": accountDetails.value
                }, null, 8, ["account-details"]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.Deposit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(AccountDetailDeposit, { "account-details": accountDetails.value }, null, 8, ["account-details"])
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.Withdrawal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(AccountDetailWithdrawal, { "account-details": accountDetails.value }, null, 8, ["account-details"])
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.PaymentMethod)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(PaymentMethodDetailForm)
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.Credit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(AccountDetailCredit)
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.Config && _ctx.$can('TenantAdmin'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(ConfigList, {
                    rowId: accountDetails.value.id,
                    category: _unref(ConfigCategory).account,
                    siteId: accountDetails.value.siteId,
                    role: accountDetails.value.role
                  }, null, 8, ["rowId", "category", "siteId", "role"])
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.Refer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(AccountReferCode, { "account-details": accountDetails.value }, null, 8, ["account-details"])
                ]))
              : _createCommentVNode("", true),
            (
          tab.value === AccountDetailTab.Stat &&
          _ctx.$cans(['TenantAdmin', 'WebTenantAccountStat'])
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(AccountDetailStat, { "account-details": accountDetails.value }, null, 8, ["account-details"])
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.Log)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(AccountDetailLog)
                ]))
              : _createCommentVNode("", true),
            (tab.value === AccountDetailTab.ApiLog && _ctx.$can('TenantAdmin'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(UserApiLog, {
                    partyId: accountDetails.value.partyId
                  }, null, 8, ["partyId"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "isLoading", "submited", "savingTitle"]))
}
}

})